<app-title-bar rootBreadCrumbs="['i18n.core.navigation.administration']" titleText="i18n.core.navigation.email-settings"></app-title-bar>
<div class="row">
  <div class="col-6">
    <div class="row">
      <div class="col">
        <h3>{{ 'i18n.domain.settings.email-settings.email-import' | translate }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-email-settings-grid [isEditModeEqualsEntry]="true"></app-email-settings-grid>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="row">
      <div class="col">
        <h3>{{ 'i18n.domain.settings.email-settings.email-export' | translate }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-email-settings-grid [isEditModeEqualsEntry]="false"></app-email-settings-grid>
      </div>
    </div>
  </div>
</div>
